<template>
  <Tour
    name="sortTour"
    :callbacks="callbacks"
    :enabled="enabled"
    :options="options"
    :steps="applicableSteps"
  />
</template>

<script>
import Tour from "./Tour";

export default {
  name: "sort-tour",
  components: { Tour },
  props: {
    enabled: Boolean
  },
  data() {
    return {
      callbacks: {
        onStop: () => {
          this.$store.dispatch("hideSortTour");
        }
      },
      steps: [
        {
          target: ".contact-sheet .header",
          header: {
            title: "Sort View"
          },
          content: `The sort view is a non-geographic window into the entire collection.`,
          params: {
            placement: "bottom"
          },
          mobile: true
        },
        {
          target: ".filters",
          header: {
            title: "Filter the Collection"
          },
          content: `Fill in the sentence blanks to see matching images below.`,
          params: {
            placement: "bottom"
          },
          mobile: true
        },
        {
          target: ".control.years",
          header: {
            title: "Pick a Year"
          },
          content: `Select a specific year to view, or look at them all together.`,
          params: {
            placement: "left-start"
          },
          mobile: true
        },
        {
          target: ".tags-include",
          header: {
            title: "Pick a Tag"
          },
          content: `Select image tags to find photos that match. Read more about
          how these tags are generated <a target="_blank" href="https://blogs.getty.edu/iris/does-it-snow-in-la/">here</a>.`,
          params: {
            placement: "left-start"
          },
          mobile: true
        },
        {
          target: ".stats .current",
          header: {
            title: "Matching Image Count"
          },
          content: `Here you can see the number of images that match your filter criteria.`,
          params: {
            placement: "right-start"
          },
          mobile: true
        },
        {
          target: ".minimap",
          header: {
            title: "Image Locations"
          },
          content: `This map shows you where those images are located across Sunset Boulevard.`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: ".shuffle-icon",
          header: {
            title: "Shuffle Images"
          },
          content: `Images are displayed in a random order. Turn off to view the collection chronologically. Turn back on to shuffle to a new random order.`,
          params: {
            placement: "right-start"
          },
          mobile: true
        },
        {
          target: ".sentence-ocr",
          header: {
            title: "Search Text in Images"
          },
          content: `You can also look for specific text in the images – from storefronts, street signs and bus stops.`,
          params: {
            placement: "bottom"
          },
          mobile: true
        },
        {
          target: ".surprise-container",
          header: {
            title: "Need Inspiration?"
          },
          content: `Click to generate a random sentence. What unexpected juxtapositions will you find?`,
          params: {
            placement: "left-start"
          },
          mobile: true
        }
      ],
      options: {
        highlight: true
      }
    };
  },
  computed: {
    applicableSteps() {
      let steps = this.steps;
      if (this.$store.state.isMobile) {
        steps = steps.filter(step => step.mobile === true);
      }
      return steps;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.v-tour--active .fullscreen.modal {
  pointer-events: all;
}

#app .v-tour .v-step {
  &.tour-sortTour {
    /* Deal with tag length changing by adding right margin */
    &-step-3 {
      margin-right: 50px;
    }

    /* Deal with surprise me button by adding a little space to the right */
    &-step-8 {
      margin-right: 50px;
    }
  }
}
</style>
